import angular from 'angular';
import { NsjRadioButtonController } from './nsj-radio-button.controller';
import { NsjRadioButtonComponent } from './nsj-radio-button.component';

export const NsjRadioButtonModule = angular.module('NsjRadioButtonModule', ['ui.router.state'])
    .controller('NsjRadioButtonController', NsjRadioButtonController)
    .component(NsjRadioButtonComponent.selector, NsjRadioButtonComponent)
    .name;
